import * as R from 'ramda'

export default (invoicesByPropertyID) => {
	let rentIncome = R.map(R.reduce((sum, invoice) => sum + (invoice.amount - invoice.balance), 0))(invoicesByPropertyID)
	rentIncome.total = R.pipe(R.values, R.reduce(R.add, 0))(rentIncome)

	return rentIncome
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/rentIncome.js